import moment from 'moment';
import 'deepmerge';

function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}

var ARDateInput = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-date-input",attrs:{"ar-widget-id":"ar-date-input","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-date-input"}},[_c('ar-simple-select',{class:[
      'u-margin-right-1' ],style:({
      width: '33%',
      height: '100%',
    }),attrs:{"color":_vm.color,"items":_vm.monthOptions,"placeholder":"MM","placeholder-props":{
      style: {
        color: _vm.$arStyle.color.blueGrey600,
      }
    },"hide-arrow":_vm.hideArrow,"enable-filter":"","enable-clear":"","default-select-index":_vm.defaultSelectedMonthIndex},on:{"select":_vm.handleMonthSelect,"clear":_vm.handleMonthClear}}),_vm._v(" "),_c('ar-input',{class:[
      'u-margin-right-1' ],style:({
      width: '33%',
      height: '100%',
    }),attrs:{"value":_vm.day,"type":"number","placeholder":"DD","autocomplete":"bday-day"},on:{"input":_vm.handleDayInput,"blur":_vm.handleDayBlur}}),_vm._v(" "),_c('ar-input',{style:({
      width: '33%',
      height: '100%',
    }),attrs:{"value":_vm.year,"placeholder":"YYYY","type":"number","autocomplete":"bday-year"},on:{"input":_vm.handleYearInput,"blur":_vm.handleYearBlur}})],1)},
staticRenderFns: [],
  name: 'DateInput',
  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    hideArrow: {
      type: Boolean,
      default: false,
    },
    isBirthday: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      monthOptions: [
        { name: 'Jan', value: '01' },
        { name: 'Feb', value: '02' },
        { name: 'Mar', value: '03' },
        { name: 'Apr', value: '04' },
        { name: 'May', value: '05' },
        { name: 'Jun', value: '06' },
        { name: 'Jul', value: '07' },
        { name: 'Aug', value: '08' },
        { name: 'Sep', value: '09' },
        { name: 'Oct', value: '10' },
        { name: 'Nov', value: '11' },
        { name: 'Dec', value: '12' },
      ],
      month: '',
      day: '',
      year: '',
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.year}-${this.month}-${this.day};`,
        `year=${this.year};`,
        `month=${this.month};`,
        `day=${this.day};`,
      ].join('');
    },
    defaultSelectedMonthIndex() {
      return this.monthOptions.findIndex(item => item.value === this.month);
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.handleValueUpdate(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    emitInput() {
      if (!this.year && !this.month && !this.day) {
        this.$emit('input', null);
      } else {
        this.$emit('input', `${this.year}-${this.month}-${this.day}`);
      }
    },
    correctYear() {
      if (!this.year) { return; }
      const year = parseInt(this.year, 10);

      if (!this.isBirthday) {
        this.emitInput();
        return;
      }

      if (year < moment().year() - 110) {
        this.year = moment().year() - 110;
        this.emitInput();
      }
      if (year > moment().year() - 1) {
        this.year = moment().year() - 1;
        this.emitInput();
      }
    },
    correctDay() {
      if (!this.year || !this.month) {
        // Only check length when month or year does not exist
        if (this.day.length === 1) {
          this.day = `0${this.day}`;
          this.emitInput();
        }
        return;
      }
      const daysInMonth = moment(`${this.year}-${this.month}`, "YYYY-MM").daysInMonth();

      const day = parseInt(this.day, 10);

      if (day === 0) {
        this.day = '01';
        this.emitInput();
      } else if (day > daysInMonth) {
        this.day = daysInMonth;
        this.emitInput();
      } else if (this.day.length === 1) {
        this.day = `0${this.day}`;
        this.emitInput();
      }
    },

    handleValueUpdate(newValue) {
      if (!newValue) { return; }
      const isNewValueValid = moment(newValue, 'YYYY-MM-DD', true);
      if (!isNewValueValid) { return; }
      const [year, month, day] = newValue.split('-');
      this.year = year;
      this.month = month;
      this.day = day;
    },

    handleMonthSelect(item) {
      this.month = item.value;
      this.emitInput();
      this.correctDay();
    },
    handleMonthClear() {
      this.month = '';
      this.emitInput();
    },
    handleDayInput(val) {
      this.day = val;
      this.emitInput();
    },
    handleDayBlur() {
      this.correctDay();
    },
    handleYearInput(val) {
      this.year = val;
      this.emitInput();
    },
    handleYearBlur() {
      this.correctYear();
      this.correctDay();
    },

  },
};

export default ARDateInput;
